import { Component } from '@angular/core';
import { select } from '@angular-redux/store';

@Component({
    selector: 'gl-header-shopping-cart-countdown-timer-visual',
    templateUrl: './header-shopping-cart-countdown-timer-visual.component.html',
    styleUrls: ['./header-shopping-cart-countdown-timer-visual.component.scss']
})
export class HeaderShoppingCartCountdownTimerVisualComponent {
    @select(['cart', 'countdownTimer']) timer$;
    @select(['cart', 'status']) status$;
}
